export default "__VITE_ASSET__e424f6cd__"